import { render, staticRenderFns } from "./scriptwriter.vue?vue&type=template&id=0ef734ab&scoped=true&"
import script from "./scriptwriter.vue?vue&type=script&lang=js&"
export * from "./scriptwriter.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef734ab",
  null
  
)

export default component.exports